import { render, staticRenderFns } from "./ComparisonLine.vue?vue&type=template&id=166c513e"
import script from "./ComparisonLine.vue?vue&type=script&lang=js"
export * from "./ComparisonLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports